import { Link } from "react-router-dom";
import { ArrowRight, Thermometer } from "lucide-react";
import { InfoPage } from "../components/info/InfoPage";
import { FactorGrid, IllustratedSplit, InfoSection } from "../components/info/InfoSections";
import { CompareTable } from "../components/info/CompareTable";
import { TextBody } from "../components/info/TextBody";
import { QuoteButton } from "../components/home/CtaButtons";
import { CHOICE_TEXT, COMFORT, GLAS_NAV, GLAS_POINTS, GLAS_SOURCES, GLASS_TABLE, HOW_TEXT } from "../data/info/glas";

const ISDE = "Bij nieuwe kozijnen met HR++ of HR+++ glas kan onder voorwaarden ISDE-subsidie gelden. Triple glas in nieuwe kozijnen heeft een hoger bedrag per m² dan HR++. RVO beslist over de aanvraag.";

const AdviceCard = () => (
  <div className="card flex flex-col gap-4 p-6 lg:col-span-5" data-testid="glas-advice-card">
    <p className="text-[18px] font-semibold text-ink">Twijfelt u tussen HR++ en HR+++?</p>
    <p className="text-[15px] leading-relaxed text-slate-600">Wij rekenen het verschil in isolatie en prijs voor uw woning uit. Geef in de aanvraag aan dat u beide wilt vergelijken.</p>
    <QuoteButton location="glas-advice" label="Vraag een prijsindicatie aan" />
    <Link to="/isde-subsidie-kozijnen#subsidiecheck" className="inline-flex items-center gap-1.5 text-[14.5px] font-semibold text-maas hover:underline" data-testid="glas-isde-link">Bekijk de subsidiemogelijkheden <ArrowRight className="h-4 w-4" aria-hidden="true" /></Link>
  </div>
);

export default function HRGlas() {
  return (
    <InfoPage page="glas" label="HR++ of HR+++ glas" eyebrow="Isolatieglas" points={GLAS_POINTS} mediaKey="ka_glas_hero" nav={GLAS_NAV}
      kbCategory="glas" faqTitle="Vragen over HR++ en HR+++ glas" endTitle="Nieuwe kozijnen met het glas dat bij uw woning past?" isdeText={ISDE} sources={GLAS_SOURCES}
      badge={{ icon: Thermometer, title: "HR+++ isoleert ca. 2× beter", text: "maar is dikker en zwaarder" }}>
      <InfoSection id="vergelijking" eyebrow="Vergelijking" title="HR++ en HR+++ glas naast elkaar"
        lead="De belangrijkste verschillen op een rij. De waarden zijn indicatief; de exacte waarde hangt af van de glasopbouw.">
        <CompareTable body={GLASS_TABLE} caption="HR++ en HR+++ glas vergeleken" testid="glas-compare-table" />
      </InfoSection>
      <InfoSection id="werking" tone="slate" eyebrow="Hoe het werkt" title="Zo houdt isolatieglas de warmte binnen">
        <IllustratedSplit mediaKey="ka_glas_detail" text={HOW_TEXT} testid="glas-how-split" />
      </InfoSection>
      <InfoSection id="keuze" eyebrow="Keuzehulp" title="Wanneer kiest u voor HR++ en wanneer voor HR+++?">
        <div className="grid gap-8 lg:grid-cols-12">
          <TextBody text={CHOICE_TEXT} className="lg:col-span-7" testid="glas-choice-text" />
          <AdviceCard />
        </div>
      </InfoSection>
      <InfoSection id="comfort" tone="slate" eyebrow="Comfort" title="Wat merkt u van beter glas?">
        <FactorGrid items={COMFORT} testid="glas-comfort" />
      </InfoSection>
    </InfoPage>
  );
}
